import {
  MapPin,
  Leaf,
  Circle,
  Settings,
  Handshake,
  Droplet,
  Users,
  Calendar,
  Heart,
  Shield,
  Sprout,
} from 'lucide-react';

export const impactIconMap = {
  mapPin: MapPin,
  settings: Settings,
  handshake: Handshake,
  leaf: Leaf,
  droplet: Droplet,
  users: Users,
  calendar: Calendar,
  heart: Heart,
  shield: Shield,
  sprout: Sprout,
};

export const getIcon = (key) => impactIconMap[key] || Circle;
